import styled from "styled-components/macro";

export const SelectStyledRoot = styled.div<{
  horizontalLabel?: boolean;
  labelShouldFloat: boolean;
  labelType?: "normal" | "floating";
  minWidth?: string;
  maxWidth?: string;
}>`
  display: flex;
  flex-direction: ${(props) => (props.horizontalLabel ? "row" : "column")};
  align-items: ${(props) => (props.horizontalLabel ? "center" : null)};
  gap: ${(props) => (props.horizontalLabel ? "0.5em" : "0.25em")};
  font-size: var(--font-size-small);
  ${(props) => (props.minWidth ? `min-width: ${props.minWidth};` : "")}
  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth};` : "")}

  .label-wrap {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  label {
    font-family: var(--inter-font);
    font-size: var(--font-size-small);
    user-select: none;
    pointer-events: none;
  }

  .error {
    color: var(--error-color);
    font-family: var(--inter-font);
    font-size: var(--font-size-small);
  }

  [aria-disabled="true"] {
    background-color: var(--border-gray) !important;
  }

  .input-container {
    position: relative;
    ${(props) => (props.minWidth ? `min-width: ${props.minWidth};` : "")}
    ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth};` : "")}

    label {
      position: absolute;
      top: ${(props) => (props.labelShouldFloat ? "0px" : "50%")};
      left: ${(props) => (props.labelShouldFloat ? "0.25rem" : "0.75rem")};
      transform: ${(props) =>
        props.labelShouldFloat ? "translateY(-50%)" : "translateY(-50%)"};
      transition: all 0.3s ease;
      background-color: ${(props) =>
        props.labelShouldFloat ? "var(--page-background)" : "transparent"};
      color: ${(props) => (props.labelShouldFloat ? undefined : "transparent")};
      padding: 0 0.25rem;
    }

    &::placeholder {
      color: var(--border-gray);
    }
    &:focus::placeholder {
      color: transparent;
    }
  }
`;
